import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  line-height: 1.5;
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 12px;
`;
